import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/rooms/create',
    name: 'CreateRoom',
    component: () => import('../views/rooms/Create.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/rooms/join/:room_id',
    name: 'JoinRoom',
    component: () => import('../views/rooms/Join.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/',
    name: 'IndexRoom',
    component: () => import('../views/rooms/Index.vue'),
    meta: {requiresAuth: true}
  },
  {
    path: '/rooms/game/:room_id',
    name: 'game',
    component: () => import('../views/rooms/Game.vue'),
    meta: {requiresAuth: true, requiresJoinedRoom: true}
  },
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/Auth/Auth.vue')
  },
  {
    path: '/howToUse',
    name: 'HowToUse',
    component: () => import('../views/HowToUse.vue')
  },
  {
    path: '/userProfile',
    name: 'UserProfile',
    component: () => import('../views/UserProfile.vue'),
    meta: {requiresAuth: true}
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const firebaseConfig = {
  apiKey: "AIzaSyD79KqP6srLjqE5XOliIqZma4LeQawwRvA",
  authDomain: "allknowingandallpowerfulgame.firebaseapp.com",
  databaseURL: "https://allknowingandallpowerfulgame.firebaseio.com",
  projectId: "allknowingandallpowerfulgame",
  storageBucket: "allknowingandallpowerfulgame.appspot.com",
  messagingSenderId: "222066599764",
  appId: "1:222066599764:web:a20da834c1193ab2a70ac1",
  measurementId: "G-B61SMT7BBN"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresJoinedRoom = to.matched.some(record => record.meta.requiresJoinedRoom);

  if (requiresAuth) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {

        // ルームに参加していなければいけない場合
        if (requiresJoinedRoom){
          firebase.firestore().collection('rooms').doc(to.params.room_id).get().then(doc=>{
            const data = doc.data();
            const members = data.members;

            if (members.some(member => member.uid === user.uid)){
              next();
            }else {
              next({name: 'index-room'});
            }
          });
        }else {
          next()
        }
      } else {
        next({
          name: 'auth' // リダイレクト先
        })
      }
    })
  } else {
    next() // next() を常に呼び出すようにしてください!
  }
})

export default router
